export default __webpack_public_path__ + "static/media/curvedDownArrowLeft.57b65ebb.svg";